<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Requisition Incoming" subTitle="Data" />

    <ListIncoming />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListIncoming from "@/components/Pages/Management/Requisition/IncomingRequisition.vue";

export default defineComponent({
  name: "ListIncomingPage",
  components: {
    PageTitle,
    ListIncoming,
  },
});
</script>
